 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"audit-log":"audit-log","auth":"auth","brand-edit~promo-banner-edit~restaurant-edit~tag-edit":"brand-edit~promo-banner-edit~restaurant-edit~tag-edit","brand-edit":"brand-edit","promo-banner-edit":"promo-banner-edit","brand-list":"brand-list","canteen-balances":"canteen-balances","canteen-calendar":"canteen-calendar","canteens":"canteens","cc-publicprint":"cc-publicprint","company-address~user-address-list":"company-address~user-address-list","company-address":"company-address","user-address-list":"user-address-list","company-allowance~company-cloudcanteen":"company-allowance~company-cloudcanteen","company-allowance~restaurant-edit":"company-allowance~restaurant-edit","company-allowance":"company-allowance","company-cloudcanteen~promo-edit":"company-cloudcanteen~promo-edit","company-cloudcanteen":"company-cloudcanteen","company-allowed-meal":"company-allowed-meal","company-balances":"company-balances","company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc":"company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc","restaurant-edit":"restaurant-edit","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit","tag-edit":"tag-edit","promo-edit":"promo-edit","company-edit":"company-edit","company-invoices":"company-invoices","delivery-edit":"delivery-edit","delivery-list":"delivery-list","tag-group-edit":"tag-group-edit","user-edit":"user-edit","custom-export-category-create":"custom-export-category-create","custom-export-category-edit":"custom-export-category-edit","custom-export-create~custom-export-edit":"custom-export-create~custom-export-edit","custom-export-create":"custom-export-create","custom-export-edit":"custom-export-edit","company-employees":"company-employees","company-list":"company-list","company-teams":"company-teams","confirm":"confirm","custom-export-category-list":"custom-export-category-list","custom-export-list":"custom-export-list","custom-export-show":"custom-export-show","home":"home","invoices-create~invoices-edit":"invoices-create~invoices-edit","invoices-create":"invoices-create","invoices-edit":"invoices-edit","invoices-dashboard":"invoices-dashboard","order-edit":"order-edit","order-preview-email":"order-preview-email","promo-banner-list":"promo-banner-list","promo-list":"promo-list","registration-codes-edit":"registration-codes-edit","registration-codes-list":"registration-codes-list","restaurant-admin":"restaurant-admin","restaurant-list":"restaurant-list","settings":"settings","tablets":"tablets","tablets-auto-login":"tablets-auto-login","tag-groups-list":"tag-groups-list","tag-list":"tag-list","todo-edit":"todo-edit","todo-list":"todo-list","translations-list":"translations-list","user-address-edit":"user-address-edit","user-list":"user-list"}[chunkId]||chunkId) + "." + {"audit-log":"dedda0da","auth":"dfe02325","brand-edit~promo-banner-edit~restaurant-edit~tag-edit":"29780911","brand-edit":"60d658c8","promo-banner-edit":"62ea9577","brand-list":"60c308ee","canteen-balances":"b9beda9c","canteen-calendar":"ef4c945c","canteens":"efcc7026","cc-publicprint":"087743bf","company-address~user-address-list":"ec18006c","company-address":"f8aa4e3c","user-address-list":"85b551f7","company-allowance~company-cloudcanteen":"220c35e6","company-allowance~restaurant-edit":"a3643d03","company-allowance":"2924ddf6","company-cloudcanteen~promo-edit":"17097bc1","company-cloudcanteen":"c29671e3","company-allowed-meal":"0079173d","company-balances":"6fa51026","company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc":"2eca1e6f","restaurant-edit":"01779a0e","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"a640cbdd","tag-edit":"62fab320","promo-edit":"e4dd995d","company-edit":"2da2bcc4","company-invoices":"5da9da01","delivery-edit":"7b5bb477","delivery-list":"513bb6b7","tag-group-edit":"04cf0a92","user-edit":"e615f15e","custom-export-category-create":"13b2f1d1","custom-export-category-edit":"1faf214e","custom-export-create~custom-export-edit":"d5e43d29","custom-export-create":"ed904663","custom-export-edit":"15e72b99","company-employees":"cb2f8f26","company-list":"136e3404","company-teams":"558170e2","confirm":"328a8cff","custom-export-category-list":"1e593fce","custom-export-list":"b840bb6e","custom-export-show":"0d05c2d3","home":"5adcb710","invoices-create~invoices-edit":"3114fe1e","invoices-create":"dcb7c8de","invoices-edit":"04863be5","invoices-dashboard":"73d81a83","order-edit":"580bb0f1","order-preview-email":"30658db4","promo-banner-list":"049ea670","promo-list":"432cfac3","registration-codes-edit":"2483b47e","registration-codes-list":"b7ebfb8e","restaurant-admin":"ecd0c47a","restaurant-list":"a4b9bf85","settings":"8e219e17","tablets":"4db1fdf7","tablets-auto-login":"0258290f","tag-groups-list":"dc8242d4","tag-list":"b5ec2ba0","todo-edit":"68da74eb","todo-list":"69c54b43","translations-list":"84f2f003","user-address-edit":"050adf00","user-list":"ea72b490"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"audit-log":1,"auth":1,"brand-edit~promo-banner-edit~restaurant-edit~tag-edit":1,"brand-edit":1,"promo-banner-edit":1,"canteen-balances":1,"canteen-calendar":1,"canteens":1,"company-address~user-address-list":1,"user-address-list":1,"company-allowance~company-cloudcanteen":1,"company-allowance~restaurant-edit":1,"company-allowance":1,"company-cloudcanteen~promo-edit":1,"company-cloudcanteen":1,"company-allowed-meal":1,"company-balances":1,"company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc":1,"restaurant-edit":1,"company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":1,"delivery-edit":1,"user-edit":1,"company-employees":1,"company-teams":1,"confirm":1,"invoices-create~invoices-edit":1,"order-edit":1,"promo-list":1,"restaurant-admin":1,"restaurant-list":1,"settings":1,"tablets":1,"tag-list":1,"todo-edit":1,"todo-list":1,"user-address-edit":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"audit-log":"audit-log","auth":"auth","brand-edit~promo-banner-edit~restaurant-edit~tag-edit":"brand-edit~promo-banner-edit~restaurant-edit~tag-edit","brand-edit":"brand-edit","promo-banner-edit":"promo-banner-edit","brand-list":"brand-list","canteen-balances":"canteen-balances","canteen-calendar":"canteen-calendar","canteens":"canteens","cc-publicprint":"cc-publicprint","company-address~user-address-list":"company-address~user-address-list","company-address":"company-address","user-address-list":"user-address-list","company-allowance~company-cloudcanteen":"company-allowance~company-cloudcanteen","company-allowance~restaurant-edit":"company-allowance~restaurant-edit","company-allowance":"company-allowance","company-cloudcanteen~promo-edit":"company-cloudcanteen~promo-edit","company-cloudcanteen":"company-cloudcanteen","company-allowed-meal":"company-allowed-meal","company-balances":"company-balances","company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc":"company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc","restaurant-edit":"restaurant-edit","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit","tag-edit":"tag-edit","promo-edit":"promo-edit","company-edit":"company-edit","company-invoices":"company-invoices","delivery-edit":"delivery-edit","delivery-list":"delivery-list","tag-group-edit":"tag-group-edit","user-edit":"user-edit","custom-export-category-create":"custom-export-category-create","custom-export-category-edit":"custom-export-category-edit","custom-export-create~custom-export-edit":"custom-export-create~custom-export-edit","custom-export-create":"custom-export-create","custom-export-edit":"custom-export-edit","company-employees":"company-employees","company-list":"company-list","company-teams":"company-teams","confirm":"confirm","custom-export-category-list":"custom-export-category-list","custom-export-list":"custom-export-list","custom-export-show":"custom-export-show","home":"home","invoices-create~invoices-edit":"invoices-create~invoices-edit","invoices-create":"invoices-create","invoices-edit":"invoices-edit","invoices-dashboard":"invoices-dashboard","order-edit":"order-edit","order-preview-email":"order-preview-email","promo-banner-list":"promo-banner-list","promo-list":"promo-list","registration-codes-edit":"registration-codes-edit","registration-codes-list":"registration-codes-list","restaurant-admin":"restaurant-admin","restaurant-list":"restaurant-list","settings":"settings","tablets":"tablets","tablets-auto-login":"tablets-auto-login","tag-groups-list":"tag-groups-list","tag-list":"tag-list","todo-edit":"todo-edit","todo-list":"todo-list","translations-list":"translations-list","user-address-edit":"user-address-edit","user-list":"user-list"}[chunkId]||chunkId) + "." + {"audit-log":"49b993ee","auth":"fb636346","brand-edit~promo-banner-edit~restaurant-edit~tag-edit":"235b4f5f","brand-edit":"ff9088fb","promo-banner-edit":"134fe02f","brand-list":"31d6cfe0","canteen-balances":"7fbdab98","canteen-calendar":"535ba9de","canteens":"2f2c9e12","cc-publicprint":"31d6cfe0","company-address~user-address-list":"7fbdab98","company-address":"31d6cfe0","user-address-list":"fca02344","company-allowance~company-cloudcanteen":"7fbdab98","company-allowance~restaurant-edit":"55b63f82","company-allowance":"9e50ca4f","company-cloudcanteen~promo-edit":"dce8d679","company-cloudcanteen":"1d483a6f","company-allowed-meal":"7fbdab98","company-balances":"7fbdab98","company-edit~company-invoices~custom-export-category-create~custom-export-category-edit~custom-expor~0e4f5bbc":"c28e8447","restaurant-edit":"d6a764b5","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"b13ba4fd","tag-edit":"31d6cfe0","promo-edit":"31d6cfe0","company-edit":"31d6cfe0","company-invoices":"31d6cfe0","delivery-edit":"25d8aac9","delivery-list":"31d6cfe0","tag-group-edit":"31d6cfe0","user-edit":"0f10bbee","custom-export-category-create":"31d6cfe0","custom-export-category-edit":"31d6cfe0","custom-export-create~custom-export-edit":"31d6cfe0","custom-export-create":"31d6cfe0","custom-export-edit":"31d6cfe0","company-employees":"7fbdab98","company-list":"31d6cfe0","company-teams":"83615244","confirm":"543e7b71","custom-export-category-list":"31d6cfe0","custom-export-list":"31d6cfe0","custom-export-show":"31d6cfe0","home":"31d6cfe0","invoices-create~invoices-edit":"663f8951","invoices-create":"31d6cfe0","invoices-edit":"31d6cfe0","invoices-dashboard":"31d6cfe0","order-edit":"9c690056","order-preview-email":"31d6cfe0","promo-banner-list":"31d6cfe0","promo-list":"74db83ac","registration-codes-edit":"31d6cfe0","registration-codes-list":"31d6cfe0","restaurant-admin":"ee7098d5","restaurant-list":"11ad9743","settings":"03488cfa","tablets":"08c4910e","tablets-auto-login":"31d6cfe0","tag-groups-list":"31d6cfe0","tag-list":"1d483a6f","todo-edit":"9e50ca4f","todo-list":"e641df34","translations-list":"31d6cfe0","user-address-edit":"7fbdab98","user-list":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
